import { render, staticRenderFns } from "./Estate.vue?vue&type=template&id=8e89b4fc&"
import script from "./Estate.vue?vue&type=script&lang=js&"
export * from "./Estate.vue?vue&type=script&lang=js&"
import style0 from "./Estate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports